function smoothScroll(position, duration, scrollTarget) {
    if (position === undefined) position = 0;
    if (duration === undefined) duration = 500;
    if (scrollTarget === undefined) scrollTarget = window;
    var isWindowTarget = scrollTarget === window;
    var start = isWindowTarget ? window.pageYOffset : scrollTarget.scrollTop;
    var distance = position - start;
    var startTime = null;
    function easeInOut(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }
    function step(timestamp) {
        if (!startTime) startTime = timestamp;
        var elapsed = timestamp - startTime;
        var progress = Math.min(elapsed / duration, 1);
        var nextPosition = start + distance * easeInOut(progress);
        if (isWindowTarget) window.scrollTo(0, nextPosition);
        else scrollTarget.scrollTop = nextPosition;
        if (elapsed < duration) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
}

//# sourceMappingURL=plentyandco.e26bcea8.js.map
